function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.16749 8.33398H10.8342V12.5007H9.16749V8.33398ZM9.16666 13.334H10.8333V15.0007H9.16666V13.334Z",
  fill: "#DA9B01"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4733 3.50023C11.1833 2.9544 10.6183 2.61523 9.99999 2.61523C9.38166 2.61523 8.81666 2.9544 8.52666 3.50107L2.41166 15.0536C2.27629 15.3074 2.20926 15.592 2.21715 15.8795C2.22504 16.1671 2.30758 16.4476 2.45666 16.6936C2.60366 16.9408 2.81272 17.1453 3.06312 17.2868C3.31352 17.4283 3.59655 17.5019 3.88416 17.5002H16.1158C16.7058 17.5002 17.24 17.1986 17.5442 16.6936C17.6932 16.4476 17.7758 16.1671 17.7837 15.8795C17.7916 15.592 17.7245 15.3074 17.5892 15.0536L11.4733 3.50023ZM3.88416 15.8336L9.99999 4.28107L16.12 15.8336H3.88416Z",
  fill: "#DA9B01"
});

var SvgErrorWarning = function SvgErrorWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgErrorWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error-warning.937e1d0d.svg";
export { ForwardRef as ReactComponent };